// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiURL: 'https://europe-west1-startelvan-dev.cloudfunctions.net',
  firebaseConfig: {
    apiKey: 'AIzaSyC3UqX6oepqzMkBRVxaIE2lKiMo8sZpxGI',
    authDomain: 'startelvan-dev.firebaseapp.com',
    databaseURL: 'https://startelvan-dev.firebaseio.com',
    projectId: 'startelvan-dev',
    storageBucket: 'startelvan-dev.appspot.com',
    messagingSenderId: '475292117727',
    appId: '1:475292117727:web:f0c81a51b33b2817ed576a',
    measurementId: 'G-CHHN78KFH6'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
